/* eslint-disable no-restricted-syntax */
import routeNames from '@/fish/router/constants'

export default [
  {
    name: routeNames.FISHERY_INFO,
    path: 'fishery-info/:regionId',
    component: () => import('@/fish/components/regions/fishery-info-card'),
  },
  {
    name: routeNames.FISHERY_SPECIES_TIPS,
    path: 'fishery-info/:regionId/:speciesSlug',
    component: () => import('@/fish/components/regions/species-tips-card'),
  },
]
